let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8PLbc")).then(() => parcelRequire('bojjP'));